import React from 'react'
import PrimaryBtn from '../../../SmallComponents/PrimaryBtn'

const ShipmentStatus = ({ shipment, statusBtns, shipmentObjUpdateEvent, statusBtnsHilightHide, statusBtnShowHidePuOut, statusBtnShowHideIT, statusBtnShowHideITDelayed, statusBtnShowHideOFD, statusBtnShowHideDEL, statusBtnShowHideScheduled, inputFieldsReadOnly, lockToDeliveredOnly, language }) => {
    let showHideScheduled = "hide"
    if (statusBtnShowHideScheduled) {
        showHideScheduled = "show"
    }

    const nonDelDisabled = inputFieldsReadOnly || lockToDeliveredOnly

    if (statusBtns === "show" || statusBtns === "hilight") {

        let tittle = "Shipment Status"
        if (language && language.code === "es") {
            tittle = "Estado del Envío"
        }
        let pickedUpText = "Picked Up"
        if (language && language.code === "es") {
            pickedUpText = "Recogido"
        }
        let inTransitText = "In Transit"
        if (language && language.code === "es") {
            inTransitText = "En Tránsito"
        }
        let transitDelayText = "Transit Delay"
        if (language && language.code === "es") {
            transitDelayText = "Retraso en el Tránsito"
        }
        let outForDeliveryText = "Out for Delivery"
        if (language && language.code === "es") {
            outForDeliveryText = "En Camino para Entrega"
        }
        let deliveredText = "Delivered"
        if (language && language.code === "es") {
            deliveredText = "Entregado"
        }
        let scheduledText = "Scheduled"
        if (language && language.code === "es") {
            scheduledText = "Programado"
        }

        return (
            <>
                {/* Mobile: compact dropdown */}
                <div className="d-block d-md-none">
                    <label className="mb-1"><strong>{tittle}</strong></label>
                    <select
                        name="status.statusId"
                        value={shipment.status.statusId}
                        onChange={shipmentObjUpdateEvent}
                        className="form-control form-control-sm"
                        disabled={inputFieldsReadOnly}
                    >
                        <option value="">-- {tittle} --</option>
                        {statusBtnShowHidePuOut !== "hide" && <option value="PU-Out" disabled={lockToDeliveredOnly}>{pickedUpText}</option>}
                        {statusBtnShowHideIT !== "hide" && <option value="IT" disabled={lockToDeliveredOnly}>{inTransitText}</option>}
                        {statusBtnShowHideITDelayed !== "hide" && <option value="IT-DELAYED" disabled={lockToDeliveredOnly}>{transitDelayText}</option>}
                        {statusBtnShowHideOFD !== "hide" && <option value="OFD" disabled={lockToDeliveredOnly}>{outForDeliveryText}</option>}
                        {statusBtnShowHideDEL !== "hide" && <option value="DEL">{deliveredText}</option>}
                        {showHideScheduled !== "hide" && <option value="SCHEDULED" disabled={lockToDeliveredOnly}>{scheduledText}</option>}
                    </select>
                </div>

                {/* Desktop: button group */}
                <fieldset className="border p-2 d-none d-md-inline-block">
                    <legend className="w-auto">{tittle}</legend>
                    <PrimaryBtn
                        btnName={pickedUpText}
                        value="PU-Out"
                        showHide={statusBtnShowHidePuOut}
                        name="status.statusId"
                        extraClass={
                            shipment.status.statusId === "PU-Out"
                                ? "btn-sm btn btn-outline-dark statusButtons active"
                                : "btn-sm btn btn-outline-dark statusButtons"
                        }
                        onClick={(event) => shipmentObjUpdateEvent(event)}
                        disabled={nonDelDisabled}
                    />
                    <PrimaryBtn
                        btnName={inTransitText}
                        value="IT"
                        showHide={statusBtnShowHideIT}
                        name="status.statusId"
                        extraClass={
                            shipment.status.statusId === "IT"
                                ? "btn-sm btn btn-outline-dark statusButtons active"
                                : "btn-sm btn btn-outline-dark statusButtons"
                        }
                        onClick={(event) => shipmentObjUpdateEvent(event)}
                        disabled={nonDelDisabled}
                    />
                    <PrimaryBtn
                        btnName={transitDelayText}
                        value="IT-DELAYED"
                        showHide={statusBtnShowHideITDelayed}
                        name="status.statusId"
                        extraClass={
                            shipment.status.statusId === "IT-DELAYED"
                                ? "btn-sm btn btn-outline-dark statusButtons active"
                                : "btn-sm btn btn-outline-dark statusButtons"
                        }
                        onClick={shipmentObjUpdateEvent}
                        disabled={nonDelDisabled}
                    />
                    <PrimaryBtn
                        btnName={outForDeliveryText}
                        value="OFD"
                        showHide={statusBtnShowHideOFD}
                        name="status.statusId"
                        extraClass={
                            shipment.status.statusId === "OFD"
                                ? "btn-sm btn btn-outline-dark statusButtons active"
                                : "btn-sm btn btn-outline-dark statusButtons"
                        }
                        onClick={shipmentObjUpdateEvent}
                        disabled={nonDelDisabled}
                    />
                    <PrimaryBtn
                        btnName={deliveredText}
                        value="DEL"
                        showHide={statusBtnShowHideDEL}
                        name="status.statusId"
                        extraClass={
                            shipment.status.statusId === "DEL"
                                ? "btn-sm btn btn-outline-dark statusButtons active"
                                : "btn-sm btn btn-outline-dark statusButtons"
                        }
                        onClick={shipmentObjUpdateEvent}
                        disabled={inputFieldsReadOnly}
                    />
                    <PrimaryBtn
                        btnName={scheduledText}
                        value="SCHEDULED"
                        showHide={showHideScheduled}
                        name="status.statusId"
                        extraClass={
                            shipment.status.statusId === "SCHEDULED"
                                ? "btn-sm btn btn-outline-dark statusButtons active"
                                : "btn-sm btn btn-outline-dark statusButtons"
                        }
                        onClick={shipmentObjUpdateEvent}
                        disabled={nonDelDisabled}
                    />
                </fieldset>
            </>)
    } else {
        return null
    }


}

export default ShipmentStatus
